import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import { OrderSettings } from 'PMT/entities/order';

// -- views
import NumberInput from 'PMT/components/form/NumberInput';
import FormGroupView from 'PMT/components/form/FormGroupView';
import TipTooltip from 'PMT/components/TipTooltip';

export default class NumberOfDaysToProposeView extends Component {

  static defaultProps = {
    numberOfDays: 0
  };

  static propTypes = {
    numberOfDays: PropTypes.number,

    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  onChange = (newValue: number) => {
    if (_.isNumber(_.toNumber(newValue))) {
      this.props.onChange(_.toNumber(newValue));
    }
  };

  //
  // Renderers
  //

  render() {
    return (
      <div>
        <FormGroupView>
          <FormGroupView.Label>
            {I18n.tr('order.settings.nb_days_to_propose_title')}
            <TipTooltip
              text={I18n.tr('order.settings.nb_days_to_propose_explaination')}
            />
          </FormGroupView.Label>
          <FormGroupView.Content>
            <div className="input-group">

              <NumberInput
                value={this.props.numberOfDays}
                onChange={this.onChange}
                format={NumberInput.INT_FORMAT}
                min={0}
                max={60}
                disabled={this.props.readOnly}
              />

              <div className="input-group-addon">
                <label>
                  {I18n.tr('order.settings.nb_days_to_propose_input_group_addon')}
                </label>
              </div>
            </div>
          </FormGroupView.Content>
        </FormGroupView>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/modes/components/NumberOfDaysToProposeView.js